<template>
  <div class="newsContentBox">
    <div class="rich-text" v-html="newsInfo.content"></div>
    <AttchMentList :attachementList="newsInfo.attachements" v-if="newsInfo.attachements" />
  </div>
</template>
<script>
import util from "@/libs/util.js";
import AttchMentList from "./attcheMentList.vue"
export default {
  props: {
    newsInfo: Object,
  },
  data() {
    return {};
  },
  mounted() {
    this.makeVideo();
  },
  methods: {
    makeVideo() {
      //显示视频
      var videoBox = document.getElementsByClassName("file-media");
      if (videoBox) {
        for (var i = 0; i < videoBox.length; i++) {
          var url = videoBox[i].attributes["data-playerarg"].value;
          url = JSON.parse(unescape(url));
          var src = this.buildResourcePath(url.file);
          var video = document.createElement("VIDEO");
          var contentBox = document.createElement("DIV");
          contentBox.classList.add("contentDiv");
          video.classList.add("videoContent");
          contentBox.style["text-align"] = "center";
          video.setAttribute("src", src);
          video.setAttribute("controls", "controls");
          videoBox[i].append(contentBox);
          contentBox.append(video);
        }
      }
    },
    buildResourcePath(src) {
      return util.buildResourcePath(src);
    },
  },
  components:{
    AttchMentList
  }
};
</script>
<style lang="scss">
.videoContent {
  max-height: 100%;
  width: 70%;
}
.rich-text {
  font-size: 14px;
  line-height: 1.6;
}
@media (max-width: 767px) {
  .videoContent{
    width: 100%;
  }
}
</style>